import * as t from "io-ts";

export const MatchCombineCodec = t.union([t.literal("ANY"), t.literal("ALL")])
export type MatchCombine = t.TypeOf<typeof MatchCombineCodec>;

export const MatchScopeCodec = t.union([t.literal("ANY"), t.literal("SPECIFIC_OR_NULL"), t.literal("SPECIFIC")])
export type MatchScope = t.TypeOf<typeof MatchScopeCodec>;

export const FieldMatchCodec = t.intersection([
  t.type({

  }),
  t.partial({
    scope: MatchScopeCodec,
    values: t.array(t.string)
  }),
]);

export type FieldMatch = t.TypeOf<typeof FieldMatchCodec>;
